var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53024 1.53036C7.82313 1.23747 7.82314 0.762595 7.53025 0.469699C7.23736 0.176804 6.76248 0.1768 6.46959 0.469691L3.99967 2.93957L1.52982 0.47019C1.2369 0.177325 0.762027 0.17737 0.469162 0.470291C0.176297 0.763212 0.176342 1.23809 0.469263 1.53095L2.939 4.00022L0.469586 6.4696C0.176691 6.76249 0.176686 7.23737 0.469578 7.53026C0.762469 7.82316 1.23734 7.82316 1.53024 7.53027L3.99976 5.06078L6.46983 7.53038C6.76275 7.82324 7.23762 7.8232 7.53049 7.53027C7.82335 7.23735 7.82331 6.76248 7.53039 6.46961L5.06043 4.00013L7.53024 1.53036Z",
    fill: "#7799A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationClose);
export default __webpack_public_path__ + "static/media/notification_close.97cf886bc296f033093ae86d408adaa1.svg";
export { ForwardRef as ReactComponent };